// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8b98fa55","186":"93863cf8","215":"72fbf840","372":"0489f9bc","377":"9e469038","738":"c7f263ce","841":"745edbb9","851":"67a10c16","856":"9048f667"}[chunkId] + ".chunk.js";
};